/* 🤖 this file was generated by svg-to-ts */
export const matIconSpaceDashboard: {
  name: 'space-dashboard';
  data: string;
} = {
  name: 'space-dashboard',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 19V5h6v14H5zm14 0h-6v-7h6v7zm0-9h-6V5h6v5z"/></svg>`
};
